/* The side panel and its controls block, as the old site's #panel / #controls (web/style.css). */
.panel {
  position: absolute; top: 0; left: 0; bottom: 0; width: var(--panel-w);
  display: flex; flex-direction: column; background: var(--surface);
  border-right: 1px solid var(--line); z-index: 2;
}
.controls { padding: 16px 16px 12px; display: flex; flex-direction: column; gap: 12px; border-bottom: 1px solid var(--line-soft); }
@media (max-width: 760px) {
  .panel { width: auto; right: 0; bottom: auto; background: transparent; border: 0; pointer-events: none; }
  .controls { pointer-events: auto; margin: 10px; padding: 12px; border: 0; border-radius: 22px; background: var(--surface); box-shadow: var(--shadow); }
}
